import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { getBase64, isImage, isVideo, isPDF, isExcel, isWord } from '@/views/claim/demageManage/utils';
import { uploadFile } from '../request';
import { quillEditor } from 'vue-quill-editor';
import { cryptoDecrypt } from '@/utils/aes';
import quillConfig from '@/views/components/editor/quill-config.js';
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: true
    },
    variables: {
      type: Object,
      default: () => {}
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    item: {
      handler(val) {
        this.form = {
          title: '',
          content: '',
          fileList: []
        };
        if (val && val.id) {
          var _this$variables$annex;
          //设置表单回显数据
          this.setFormData(val);
          if (this.variables && ((_this$variables$annex = this.variables.annexe) === null || _this$variables$annex === void 0 ? void 0 : _this$variables$annex.length) > 0) {
            let annexe = JSON.parse(JSON.stringify(this.variables.annexe));
            this.attachmentVariable = annexe.map(item => {
              item.isCheck = false;
              return item;
            });
            this.updateDataVariable(val);
          }
        }
      },
      deep: true,
      immediate: true
    },
    variables: {
      handler(val) {
        var _val$annexe;
        if (val && ((_val$annexe = val.annexe) === null || _val$annexe === void 0 ? void 0 : _val$annexe.length) > 0) {
          let annexe = JSON.parse(JSON.stringify(val.annexe));
          this.attachmentVariable = annexe.map(item => {
            item.isCheck = false;
            return item;
          });
          if (this.item) {
            console.log(JSON.parse(JSON.stringify(this.item, 111)));
            this.updateDataVariable(this.item);
          }
        }
      },
      deep: true,
      immediate: true
    },
    isEdit: {
      handler(val) {
        this.disableEditor(val);
      },
      immediate: true
    }
  },
  mounted() {
    this.disableEditor(this.isEdit);
  },
  data() {
    return {
      form: {
        title: '',
        content: '',
        fileList: []
      },
      action: uploadFile,
      previewVisible: false,
      previewSrc: '',
      currentPreviewIndex: 0,
      fileType: '',
      attachmentVariable: [],
      quillOption: quillConfig
    };
  },
  computed: {
    rules() {
      return {
        title: [{
          min: 0,
          max: 200,
          message: this.$t('请输入0-200字符'),
          trigger: 'blur'
        }],
        content: [{
          required: true,
          validator: this.checkEditorCont,
          trigger: 'change'
        }]
      };
    }
  },
  components: {
    quillEditor,
    previewModal
  },
  methods: {
    disableEditor(status) {
      console.log(status, '--------disableEditor status---------', !status);
      // 禁用所有工具栏按钮
      const toolbarButtons = document.querySelectorAll('.ql-toolbar button');
      console.log(toolbarButtons, 'toolbarButtons');
      toolbarButtons.forEach(button => {
        button.disabled = status ? false : true;
      });
    },
    // 校验富文本是否有真实内容
    checkEditorCont(rule, value, callback) {
      const editorContent = this.$refs.myTextEditor.quill.root.innerHTML;
      // 使用DOMParser解析HTML字符串为DOM对象
      const parser = new DOMParser();
      const doc = parser.parseFromString(editorContent, 'text/html');
      // 获取解析后的文本内容
      const textContent = doc.body.textContent || '';
      const trimContent = textContent.trim();
      if (!trimContent && !editorContent.includes('<img')) {
        callback(new Error(this.$t('请输入') + this.$t('邮件正文')));
      } else if (trimContent && trimContent.length > 1024) {
        callback(new Error(this.$t('请输入1-1024字符')));
      } else {
        callback();
      }
    },
    updateDataVariable(resetItem) {
      var _resetItem$annexVaria;
      let variables = ((_resetItem$annexVaria = resetItem.annexVariable) === null || _resetItem$annexVaria === void 0 ? void 0 : _resetItem$annexVaria.split(',')) || [];
      this.attachmentVariable.forEach(item => {
        if (variables.includes(item.mark)) {
          item.isCheck = true;
        } else {
          item.isCheck = false;
        }
      });
      this.attachmentVariable = [...this.attachmentVariable];
    },
    setFormData(resetItem) {
      this.form.fileList = resetItem.uploadFiles ? JSON.parse(resetItem.uploadFiles) : [];
      this.form.content = resetItem.content || '';
      this.form.title = resetItem.title || '';
    },
    cancelForm() {
      this.setFormData(this.item);
      this.updateDataVariable(this.item);
      this.$refs.emailForm.validate();
    },
    beforeUpload(file, info) {
      //上传文件前限制最多只能上传10个附件
      return new Promise((resolve, reject) => {
        const typeReg = /(docx|doc|xlsx|xls|mp4|jpg|pdf|jpeg|png)$/;
        const filename = (file === null || file === void 0 ? void 0 : file.name) || '';
        const imgSuffix = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
        const isFileTypeError = typeReg.test(imgSuffix);
        let fileSizes = file.size / 1024 / 1024;
        if (this.form.fileList.length >= 10) {
          this.$message.error(this.$t('最多上传10条附件'));
          reject(false);
        } else if (!isFileTypeError) {
          this.$message.error(this.$t('上传格式错误'));
          reject(false);
        } else if (fileSizes > 100) {
          this.$message.error(this.$t('文件大小超过100mb'));
          reject(false);
        } else {
          resolve(true);
        }
      });
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this.form.fileList[this.form.fileList.length - 1].status = 'error';
        }
      }
      let fileList = info.fileList;
      this.form.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
    },
    changeCheck(item) {
      // 附件变量点击切换
      if (!this.isEdit) return;
      this.$set(item, 'isCheck', !item.isCheck);
    },
    cancelPre() {
      this.previewVisible = false;
      this.previewSrc = '';
      this.currentPreviewIndex = 0;
    },
    async previewFile(file) {
      //文件预览 图片和视频弹窗预览 其他文件新打开页面
      this.fileType = '';
      let type = file.url.substring(file.url.lastIndexOf('.')).substring(1).toLowerCase();
      if (isImage(type)) {
        this.fileType = 'image';
      }
      if (isVideo(type)) {
        this.fileType = 'video';
      }
      //excel
      if (isExcel(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewXLSX = urlid + file.url;
        window.open(this.previewXLSX);
      }
      // doc格式
      if (isWord(type)) {
        const urlid = 'https://view.officeapps.live.com/op/view.aspx?src=';
        this.previewDocx = urlid + file.url;
        window.open(this.previewDocx);
      }
      this.isPDFShow = isPDF(type);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.fileType === 'image' || this.fileType === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.form.fileList.findIndex(item => item.uid === file.uid);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    }
  }
};